var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sideCollapse",attrs:{"id":"domColapse"}},[_c('i',{class:{ 'el-icon-s-unfold': _vm.opened, 'el-icon-s-fold': !_vm.opened },on:{"click":function($event){return _vm.toggleOpen()}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20961b7a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SideCollapse/index.vue
// module id = null
// module chunks = 